module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin.ddc6187e.jpg";